import React from 'react';

import {useKnowledgeBases} from 'app/kbs/api';
import {gt} from 'app/utils/i18n';

import {KBItemList} from './KBItemList';

import {KnowledgebaseSerializedType} from 'sweet-types';
type KnowledgeBaseSelectionListProps = {
  refreshPosition: () => void;
  setCurrentKb: (KnowledgebaseSerializedType) => void;
};

export const KnowledgeBaseSelectionList = ({
  refreshPosition,
  setCurrentKb,
}: KnowledgeBaseSelectionListProps) => {
  const {data: kbData} = useKnowledgeBases({});

  return (
    <KBItemList
      kbList={kbData?.results}
      itemName={gt('knowledge base')}
      refreshPosition={refreshPosition}
      setParentFolder={(knowledgebase: KnowledgebaseSerializedType) =>
        setCurrentKb(knowledgebase)
      }
      defaultKBIcon={'far fa-book-open'}
    />
  );
};
